<template>
    <div>
        <v-row class="mb-2 px-2 px-md-4">
            <v-col cols="12">
                <v-card class="pa-4" :color="'#FBFAF1'" outlined>
                    <div class="d-flex flex-column flex-md-row justify-space-between align-start align-md-center">
                        <div>
                            <div class="text-h6 font-weight-bold perfil-titulo">Proformas</div>
                            <div class="text-body-2 grey--text text--darken-1 mt-1">
                                Listado de proformas emitidas para la agencia.
                            </div>
                        </div>
                        <v-chip color="blue lighten-4" text-color="blue darken-3" class="mt-3 mt-md-0" small>
                            {{ proformas.length }} registros
                        </v-chip>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="px-2 px-md-4">
            <v-col cols="12">
                <v-card class="pa-4" outlined :color="'#FBFAF1'">
                    <v-alert v-if="mensajeError" type="error" dense text class="mb-4">
                        {{ mensajeError }}
                    </v-alert>

                    <v-alert v-if="!loading && !mensajeError && !proformas.length" type="info" dense text class="mb-4">
                        No hay proformas disponibles para esta agencia.
                    </v-alert>

                    <v-row dense class="mb-3">
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="filtros.fecha"
                                label="Filtrar fecha"
                                outlined
                                dense
                                clearable
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="filtros.codigo"
                                label="Filtrar expediente"
                                outlined
                                dense
                                clearable
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="filtros.documento"
                                label="Filtrar documento"
                                outlined
                                dense
                                clearable
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-data-table
                        v-if="proformas.length || loading"
                        locale="es"
                        dense
                        hide-default-footer
                        :loading="loading"
                        :headers="headers"
                        :items="proformasFiltradas"
                        :items-per-page="-1"
                        class="elevation-1 alternating-rows bordered-table"
                    >
                        <template v-slot:[`item.fecha`]="{ item }">
                            <span>{{ formatearFecha(item.fecha) }}</span>
                        </template>

                        <template v-slot:[`item.tipo`]="{ item }">
                            <v-chip small label color="teal lighten-4" text-color="teal darken-3">
                                {{ item.tipo || 'PROFORMA' }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.url_pdf`]="{ item }">
                            <div class="d-flex align-center justify-space-between">
                                <span class="doc-nombre mr-3">{{ getNombreDocumento(item.url_pdf) }}</span>
                                <v-btn
                                    v-if="item.url_pdf"
                                    small
                                    text
                                    class="pa-0"
                                >
                                    <v-chip
                                        small
                                        label
                                        color="blue darken-2"
                                        dark
                                        :href="item.url_pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Ver
                                    </v-chip>
                                </v-btn>
                                <span v-else>-</span>
                            </div>
                        </template>

                        <template v-slot:no-data>
                            No hay proformas disponibles para esta agencia.
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

export default {
    name: 'ProformasSection',
    data() {
        return {
            loading: false,
            mensajeError: '',
            proformas: [],
            filtros: {
                fecha: '',
                codigo: '',
                tipo: '',
                documento: ''
            },
            headers: [
                { text: 'FECHA', value: 'fecha', sortable: true, width: '110px' },
                { text: 'EXPEDIENTE', value: 'codigo', sortable: false, width: '100px' },
                { text: 'TIPO', value: 'tipo', sortable: false, width: '95px' },
                { text: 'PDF', value: 'url_pdf', sortable: false, align: 'center', width: '120px' }
            ]
        };
    },
    computed: {
        ...mapState('auth', ['access_token', 'user']),
        origenId() {
            const origen = this.user && this.user.origen ? this.user.origen : null;
            if (!origen) return null;

            if (origen.id !== null && origen.id !== undefined && origen.id !== '') {
                return origen.id;
            }

            if (origen.identificador !== null && origen.identificador !== undefined && origen.identificador !== '') {
                return origen.identificador;
            }

            return null;
        },
        proformasOrdenadas() {
            return [...this.proformas].sort((a, b) => {
                const fechaA = new Date(a && a.fecha ? a.fecha : 0).getTime();
                const fechaB = new Date(b && b.fecha ? b.fecha : 0).getTime();
                return fechaB - fechaA;
            });
        },
        proformasFiltradas() {
            const fechaFiltro = this.normalizarTexto(this.filtros.fecha);
            const codigoFiltro = this.normalizarTexto(this.filtros.codigo);
            const tipoFiltro = this.normalizarTexto(this.filtros.tipo);
            const documentoFiltro = this.normalizarTexto(this.filtros.documento);

            return this.proformasOrdenadas.filter((item) => {
                const fecha = this.formatearFecha(item.fecha);
                const codigo = item && item.codigo ? item.codigo : '';
                const tipo = item && item.tipo ? item.tipo : 'PROFORMA';
                const documento = this.getNombreDocumento(item && item.url_pdf ? item.url_pdf : '');

                if (fechaFiltro && !this.normalizarTexto(fecha).includes(fechaFiltro)) return false;
                if (codigoFiltro && !this.normalizarTexto(codigo).includes(codigoFiltro)) return false;
                if (tipoFiltro && !this.normalizarTexto(tipo).includes(tipoFiltro)) return false;
                if (documentoFiltro && !this.normalizarTexto(documento).includes(documentoFiltro)) return false;

                return true;
            });
        }
    },
    async mounted() {
        await this.cargarProformas();
    },
    methods: {
        async cargarProformas() {
            if (!this.origenId) {
                this.mensajeError = 'No se pudo identificar la agencia para cargar las proformas.';
                this.proformas = [];
                return;
            }

            this.loading = true;
            this.mensajeError = '';

            try {
                const response = await Vue.axios({
                    method: 'GET',
                    url: `/proformas-agencia/${this.origenId}`,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    }
                });

                const payload = response && response.data ? response.data : {};
                this.proformas = Array.isArray(payload.data) ? payload.data : [];
            } catch (e) {
                this.proformas = [];
                this.mensajeError = 'No se pudieron cargar las proformas. Inténtalo de nuevo.';
            } finally {
                this.loading = false;
            }
        },
        formatearFecha(fecha) {
            if (!fecha) return '-';
            const d = new Date(fecha);
            if (isNaN(d.getTime())) return fecha;
            return d.toLocaleDateString('es-ES');
        },
        getNombreDocumento(url) {
            if (!url) return '-';

            const limpio = String(url).split('?')[0].split('#')[0];
            const partes = limpio.split('/');
            return partes[partes.length - 1] || url;
        },
        normalizarTexto(valor) {
            return String(valor || '')
                .toLowerCase()
                .trim();
        }
    }
};
</script>

<style scoped>
.perfil-titulo {
    color: #191970;
}

.doc-nombre {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 260px;
}
</style>
